import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { CredentialsService } from './credentials.service';

import { PERMISSIONS } from '@app/constants/PERMISSIONS';
import { UtilService } from '@app/shared/services/util.service';
import { ROLES } from '@app/constants';

@Injectable()
export class AuthenticationGuard {
    constructor(
        private _router: Router,
        private _utilService: UtilService,
        private _credentialsService: CredentialsService
    ) {
        console.log('validate');
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {
        if (
            this._credentialsService.isAuthenticated() &&
            this._credentialsService.credentials.user
        ) {
            const role = this._credentialsService.credentials.user.role;
            const roleArr = PERMISSIONS;
            const url = state.url.split('/');
            if (
                role === ROLES.ADMINISTRATOR ||
                (roleArr[role] && roleArr[role].includes(url[1]))
            ) {
                return true;
            } else {
                console.error('can`t enter');
                if (role === ROLES.PROVEEDOR) {
                    this._router.navigate(['/premiums']);
                    this._utilService.presentToast(
                        `No estás autorizado para ingresar a la ruta ${state.url}`,
                        'error',
                        5000
                    );
                } else {
                    this._utilService.presentToast(
                        `No estás autorizado para ingresar a la ruta ${state.url}`,
                        'error',
                        5000
                    );
                    this._router.navigate(['/home']);
                }
                return false;
            }
        } else {
            console.error(
                'Not authenticated, redirecting and adding redirect url...'
            );
            this._router.navigate(['/login'], {
                queryParams: { redirect: state.url },
                replaceUrl: true
            });
            return false;
        }
    }
}
